export const TRANSFORMATION = 'TRANSFORMATION';
export const METADATA = 'METADATA';
export const SEEN_BEFORE = 'SEEN_BEFORE';
export const X_RAY = 'X_RAY';
export const DATABASES = 'DATABASES';
export const CUSTOM_RULE = 'CUSTOM_RULE';
export const FLATTENED_PDF = 'FLATTENED_PDF';
export const ANOMALY = 'ANOMALY';
